<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 21.832 17">
      <g transform="translate(1.832 1)">
          <path v-if="hasShadow !== false" class="shadow" d="M9,0l4,7H-2Z" transform="translate(18 16) rotate(180)"/>
          <g class="triangle-wrap" :style="{'fill': fillColor}" transform="translate(18 14) rotate(180)">
              <path class="inner-triangle"
                    d="M 18.91583061218262 14.5 L 18 14.5 L 0 14.5 L -0.9158300161361694 14.5 L -0.4205900132656097 13.7296199798584 L 8.579409599304199 -0.2703799903392792 L 9 -0.9246299862861633 L 9.420590400695801 -0.2703799903392792 L 18.42058944702148 13.7296199798584 L 18.91583061218262 14.5 Z"/>
              <path class="triangle-stroke" :style="{'fill': strokeColor}" d="M 9 0 L 0 14 L 18 14 L 9 0 M 9 -1.849260330200195 L 9.841179847717285 -0.5407600402832031 L 18.8411808013916 13.4592399597168 L 19.8316707611084 15 L 18 15 L 0 15 L -1.831670761108398 15 L -0.8411808013916016 13.4592399597168 L 8.158820152282715 -0.5407600402832031 L 9 -1.849260330200195 Z"/>
          </g>
      </g>
  </svg>
</template>

<script>
  export default {
    name: "WHINTriangleMarker",
    props: {
      "isSelected": {
        type: Boolean,
        default: false,
        required: false,
      },
      "isHighlighted": {
        type: Boolean,
        default: false,
        required: false,
      },
      "hasShadow": {
        type: Boolean,
        default: false,
        required: false,
      },
      "width": {
        type: Number,
        default: 21.832,
        required: false,
      },
    },
    computed: {
      height() {
        return this.width * .7789;
      },
      fillColor() {
        if (this.isHighlighted) {
          return '#51FFF1';
        } else {
          return '#00BFB0';
        }
      },
      strokeColor() {
        if (this.isSelected) {
          return '#ffffff';
        } else {
          return '#707070';
        }
      }
    }
  }
</script>

<style scoped>
  .shadow{opacity: 0.33;}
  .triangle-wrap {
    /* default fill is WHIN teal */
    fill: #00bfb0;
  }
  .inner-triangle,.triangle-stroke {stroke:none;}
  .triangle-stroke {
    /* default stroke is grey */
    fill: #707070;
  }
</style>